// JavaScript Document

String.prototype.capitalise = function () {
    if (this.charAt != undefined)
        return this.charAt(0).toUpperCase() + this.slice(1);
    else
        return this;
}


export function datesEqual(a, b) {
   return (!(a>b || b>a))
}


// Prepare the date for the XML request
export function formatDateString(myString, isStartDate) {
	// Handle the general year options at the top of each list
	if (myString.length == 4 && isStartDate) {
		return '01/01/' + myString;
    }

	if (myString.length == 4 && !isStartDate) {
		return '31/12/' + myString;	
	}

	var dd = String(myString.match(/[0-9]{1,2} /));
	var mm = String(myString.match(/[a-zA-Z]+/));
	var yyyy = String(myString.match(/ [0-9]{2}/));

	// Remove the trailing space at the end of dd
	dd = dd.substring(0, dd.length - 1);
	if (dd.length < 2) {
		dd = '0' + dd;
	}
	
	// Remove the leading space at the start of yyyy and add 20 at the start
	yyyy = '20' + yyyy.substring(1, 3);

	switch(mm.toLowerCase()) {
		case 'jan':
			mm = '01';
			break;
		case 'feb':
			mm = '02';
			break;
		case 'mar':
			mm = '03';
			break;
		case 'apr':
			mm = '04';
			break;
		case 'may':
			mm = '05';
			break;
		case 'jun':
			mm = '06';
			break;
		case 'jul':
			mm = '07';
			break;
		case 'aug':
			mm = '08';
			break;
		case 'sep':
			mm = '09';
			break;
		case 'oct':
			mm = '10';
			break;
		case 'nov':
			mm = '11';
			break;
		case 'dec':
			mm = '12';
			break;
	}

	return dd + '/' + mm + '/' + yyyy;
}

export function dateFormatForSearch(d) {
    //Date format eg: 5 May 12.
    var monthNames = new Array("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec");
    var x = new Date(d);
    var day = x.getDate();
    var month = monthNames[x.getMonth()];
    var year =  '' + x.getFullYear();

    return day + ' ' + month + ' ' + year.substr(2);
}

export function dateFormatForDisplay(d) {
    //Date format eg: 5 May 12.
    var monthNames = new Array("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec");
    var dayNames = new Array("Sun","Mon", "Tue", "Wed", "Thu", "Fri", "Sat");
    var x = new Date(d);
    var day = x.getDate();
    var dayName = dayNames[x.getDay()];
    var month = monthNames[x.getMonth()];
    var year = '' + x.getFullYear();

    return dayName + ' ' + day + ' ' + month + ' ' + year;
} 



export function formatArrivalDayString(day) {
	if (day.length < 2) {
		return '0' + day;
	}
	return day;
}

export function formatArrivalMonthString(monthYear) {
	var month = monthYear.substring(0, 3);
	var year = monthYear.substring(4);
	return month + '%20' + year; // Add a url-encoded space between the month and year
}


export function getShortDayStr(num) {
	switch(num) {
		case 0:
			return 'S';
			break;
		case 1:
			return 'M';
			break;
		case 2:
			return 'T';
			break;
		case 3:
			return 'W';
			break;
		case 4:
			return 'T';
			break;
		case 5:
			return 'F';
			break;
		case 6:
			return 'S';
			break;
        default:
            return '';
	}
}
export function getMedDayStr(num) {
    switch (num) {
        case 0:
            return 'Su';
            break;
        case 1:
            return 'Mo';
            break;
        case 2:
            return 'Tu';
            break;
        case 3:
            return 'We';
            break;
        case 4:
            return 'Th';
            break;
        case 5:
            return 'Fr';
            break;
        case 6:
            return 'Sa';
            break;
        default:
            return '';
    }
}

export function getLongDayStr(num) {
	switch(num) {
		case 0:
			return 'Sun';
			break;
		case 1:
			return 'Mon';
			break;
		case 2:
			return 'Tue';
			break;
		case 3:
			return 'Wed';
			break;
		case 4:
			return 'Thu';
			break;
		case 5:
			return 'Fri';
			break;
		case 6:
			return 'Sat';
			break;
        default:
            return '';
	}
}

export function getFullDayStr(num) {
    switch (num) {
        case 0:
            return 'Sunday';
            break;
        case 1:
            return 'Monday';
            break;
        case 2:
            return 'Tuesday';
            break;
        case 3:
            return 'Wednesday';
            break;
        case 4:
            return 'Thursday';
            break;
        case 5:
            return 'Friday';
            break;
        case 6:
            return 'Saturday';
            break;
        default:
            return '';
    }
}

export function getMonthStr(num) {
	switch(num) {
		case 0:
			return 'january';
			break;
		case 1:
			return 'february';
			break;
		case 2:
			return 'march';
			break;
		case 3:
			return 'april';
			break;
		case 4:
			return 'may';
			break;
		case 5:
			return 'june';
			break;
		case 6:
			return 'july';
			break;
		case 7:
			return 'august';
			break;
		case 8:
			return 'september';
			break;
		case 9:
			return 'october';
			break;
		case 10:
			return 'november';
			break;
		case 11:
			return 'december';
			break;
        default:
            return '';
	}
}

export function getReadableDateStr(myDate) {
    var dateString = getLongDayStr(myDate.getDay()) + ' ' + myDate.getDate() + ' ' + getMonthStr(myDate.getMonth()).capitalise().substring(0, 3) + ' ' + myDate.getFullYear();
	return dateString;
}

export function getReadableDateStrFullWeekday(myDate) {
    var dateString = getFullDayStr(myDate.getDay()) + ' ' + myDate.getDate() + ' ' + getMonthStr(myDate.getMonth()).capitalise().substring(0, 3) + ' ' + myDate.getFullYear();
    return dateString;
}

export function getReservationDateStr(myDate) {
	var date = String(myDate.getDate());
	var month = String(myDate.getMonth() + 1);
	var year = String(myDate.getFullYear());

	date = (date.length < 2) ? '0' + date : date;
	month = (month.length < 2) ? '0' + month : month;
	
	return date + '/' + month + '/' + year;
}